import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import apiStore from "../../../../../../../utils/apiStore";
import MyIcons from "../../../../../../golbal/icons/myIcons";
import ToastNote from "../../../../../../golbal/notifications/toastNote";
import renderData from "../../../../../../../utils/renderData";
import SearchBarUser from "./searchBarUser";
import ColoredSpinner from "../../../../../../alret/spiners/coloredSpiner/coloredSpinner";
import tools from "../../../../../../../utils/tools";
import { CartContext } from "../../../../../../contexts/cartContext";
import MetaDecorator from "../../../../../../../utils/metaDecorator";

export default function MyOrderList({ access, section }) {
  const { user } = useContext(CartContext);
  const [countryShort, stateShort] = window.location.pathname
    .toLowerCase()
    .split("/")
    .slice(2, 4);

  const navigate = useNavigate();
  const trans = {
    orderRemoved:{en:'Order successfully removed.',fa:"سفارش با موفقیت حذف شد."},
    action:{en:'Action',fa:"عملیات"},
    paid:{en:'Paid',fa:"تکمیل سفارش"},
    country:{en:'Country',fa:"کشور"},
    facility:{en:'Facility',fa:"نام امکانات"},
    amount:{en:'Total Amount',fa:"مبلغ صورتحساب"},
    invNumber:{en:'Invoice Number',fa:"شماره صورتحساب"},   
    date:{en:'Date',fa:"تاریخ"},
    inOrders:{en:'Incompleted Orders',fa:'لیست سفارشهای ناتمام'},
    inOrdersDesc:{en:'View Incompleted Orders and Invoices',fa:"مشاهده صورتحساب ها و سفارشهای ناتمام "},
    NoData:{en:'No data is available.',fa:"داده ای پیدا نشد. پس از اطمینان از وجود داده، دوباره تلاش کنید."},
   
  }

  const messageRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [user2, setUser2] = useState({ _id: user._id });

  const deleteHandle = async (id) => {
    console.log(id);
    if (!id)
      return messageRef.current.showError({ message: "Id is not provided" });
    const response = await apiStore.deleteRow({
      token: user.token,
      id,
      userId: user._id,
    });
    if (response.error)
      return messageRef.current.showError({ message: response.error });
    messageRef.current.showSuccess({ message: trans.orderRemoved[window.lang] });
    setData((pre) => {
      return pre.filter((row) => row._id !== id);
    });
  };
  function showPageHandle({ props }) {
    let text = "";
    // if (window.lang !== props.lang.toLowerCase())
    //   text += `شما در حال انتقال به متامارس با زبان ${window.capitalize(
    //     props.lang
    //   )} میباشد . \n`;
    // if (countryShort.toLowerCase() !== props.address.countryShort.toLowerCase())
    //   text += `شما در حال انتقال به کشور ${window.capitalize(
    //     props.address.country
    //   )} میباشد . \n`;
    // if (stateShort.toLowerCase() !== props.address.stateShort.toLowerCase())
    //   text += `شما در حال انتقال به استان ${window.capitalize(
    //     props.address.state
    //   )} میباشد . \n`;

    if (!text.length)
      return navigate(`/${window.lang}/store/order/${props._id}`);

    if (window.confirm(text) != true) return;
    console.log("Passed");

    navigate(`/${window.lang}/store/order/${props._id}`);
  }

  useEffect(() => {
    fetchData();
  }, [user2._id, window.location.pathname]);
  async function fetchData() {
    setLoading(true);
    const response = await apiStore.getOrdersList({
      token: user.token,
      id: user2._id,
      access,
      section,
    });
    setLoading(false);
    console.log(response);
    if (response.error) return alert(response.error);
    setData(response.data);
  }

  function showPrice(amount, currency) {
    const cur = currency || "USD";
    const final = (amount || 0).toLocaleString(window.lang, {
      style: "currency",
      currency: cur,
      minimumFractionDigits: cur === "IRR" ? 0 : 2,
      maximumFractionDigits: cur === "IRR" ? 0 : 2,
    });
    return final;
  }

  const columns = [
    //   { field: '_id', headerName: 'ID', width: 70 },
    {
      field: "action",
      headerName: trans.action[window.lang],
      width: 150,
      renderCell: (params) => {
        return (
          <div className="d-flex">
            <div
              to={""}
              title="Show"
              className="widgetSmButton"
              onClick={(e) => showPageHandle({ props: params.row })}
            >
              <MyIcons icon="display" />
            </div>
            {/* <Link to={""} title="ویرایش" className="widgetSmButton"><Edit className='widgetSmIcon ' onClick={e => editOrderHandle({props:params.row})}/></Link> */}
            {!params.row.isPaid && (
              <Link
                to={""}
                title="Delete"
                onClick={() => deleteHandle(params.row._id)}
              >
                <MyIcons icon="delete2" />
              </Link>
            )}
          </div>
        );
      },
    },
    {
      field: "createdAt",
      headerName: trans.date[window.lang],
      width: 100,
      renderCell: (params) => (
        <div title={tools.toSolar(params.row?.updatedAt)}>
          {tools.toGreg(params.row?.updatedAt)}
        </div>
      ),
    },
    {
      field: "isPaid",
      headerName: trans.paid[window.lang],
      width: 100,
      renderCell: (params) => <div>{params.row.isPaid ? "Yes" : "No"}</div>,
    },
    {
      field: "address.country",
      headerName: trans.country[window.lang],
      width: 150,
      renderCell: (params) => (
        <div dir="ltr">{`${window.capitalize(
          params.row?.address?.state
        )}, ${window.capitalize(params.row?.address?.country)}`}</div>
      ),
    },
    {
      field: "serviceItems",
      headerName: trans.facility[window.lang],
      width: 200,
      renderCell: (params) => {
        return params.row.serviceItems.map((serv, i) => (
          <span key={i}>
            <span title={serv.title}>
              {
                renderData.plansName.find((plan) => plan.name === serv?.type)?.[
                  window.lang
                ]
              }
            </span>
            -
          </span>
        ));
      },
    },
    {
      field: "totalPrice",
      headerName: trans.amount[window.lang],
      width: 150,
      renderCell: (params) => (
        <div
          title={` paid  ${showPrice(
            Number(params.row?.paymentResult[0]?.amount?.value),
            params.row?.paymentResult[0]?.amount?.currency_code
          )}`}
        >
          {showPrice(params.row?.totalPrice, params.row?.currency)}
        </div>
      ),
    },
    {
      field: "invNumber",
      headerName: trans.invNumber[window.lang],
      width: 150,
      // renderCell:params=>  <div title={params.row?.paymentResult[0]?.amount?.value}>{params.row?.paymentResult[0]?.amount?.currency_code+params.row?.paymentResult[0]?.amount?.value}</div>
    },
  ];
  const metaTagsData = {
    title: trans.inOrders[window.lang],
    description: trans.inOrdersDesc[window.lang],
    section: "oreders list",
    url: `${window.location.origin}/${window.lang}/dashboard/user/trans/points`,
    // canonical: `${window.location.origin}/${window.lang}/dashboard/user/trans/points`,
    img: "https://www.metamarce.com/img/illustration/buy-photography-gear-online.svg",
    type: "webpage",
    index: false,
  };
  // console.log('data',data);
  return (
    <div className="userList" style={{ height: "80vh", width: "100%" }}>
      <MetaDecorator data={{ ...metaTagsData }} />
      <ToastNote messageRef={messageRef} />

      {loading && <ColoredSpinner />}
      {!data.length ? (
        <div> {trans.NoData[window.lang]}        
        </div>
      ) : (
        <DataGrid
          getRowId={(row) => row._id}
          rows={data}
          components={{
            Toolbar: GridToolbar,
          }}
          disableSelectionOnClick
          columns={columns}
          pageSize={[15]}
          rowsPerPageOptions={[1]}
          checkboxSelection
        />
      )}
      {access === "admin" && (
        <SearchBarUser setUser2={setUser2} user2={user2} />
      )}
    </div>
  );
}
